var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["./partials/account-navigation.j2"] = require( "./partials/account-navigation.j2" );
dependencies["./partials/wishlist-new-list-small.j2"] = require( "./partials/wishlist-new-list-small.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/account-navigation-wrapper.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/account-navigation-wrapper.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("accountUrl")) {
var t_4 = t_1.accountUrl;
} else {
cb(new Error("cannot import 'accountUrl'")); return;
}
context.setVariable("accountUrl", t_4);
if(t_1.hasOwnProperty("wishlistUrl")) {
var t_5 = t_1.wishlistUrl;
} else {
cb(new Error("cannot import 'wishlistUrl'")); return;
}
context.setVariable("wishlistUrl", t_5);
if(t_1.hasOwnProperty("ordersUrl")) {
var t_6 = t_1.ordersUrl;
} else {
cb(new Error("cannot import 'ordersUrl'")); return;
}
context.setVariable("ordersUrl", t_6);
if(t_1.hasOwnProperty("registryUrl")) {
var t_7 = t_1.registryUrl;
} else {
cb(new Error("cannot import 'registryUrl'")); return;
}
context.setVariable("registryUrl", t_7);
if(t_1.hasOwnProperty("favoritesUrl")) {
var t_8 = t_1.favoritesUrl;
} else {
cb(new Error("cannot import 'favoritesUrl'")); return;
}
context.setVariable("favoritesUrl", t_8);
if(t_1.hasOwnProperty("ugcUrl")) {
var t_9 = t_1.ugcUrl;
} else {
cb(new Error("cannot import 'ugcUrl'")); return;
}
context.setVariable("ugcUrl", t_9);
output += "\n\n<div class=\"dom-account-navigation o-column o-extra-small--12 o-medium--3 o-large--2 c-account-navigation js-account-navigation\">\n\n    ";
output += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "useGrid")) {
output += "\n\n        <div class=\"o-row s-account-navigation-wishlist\">\n\n            <div class=\"g-account-navigation__dropdown\">\n    \n                ";
env.getTemplate("./partials/account-navigation.j2", false, "core/templates/account-navigation-wrapper.j2", null, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "\n\n            </div>\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
output += "\n\n                <div class=\"g-account-navigation__add-new-list\">\n\n                    ";
env.getTemplate("./partials/wishlist-new-list-small.j2", false, "core/templates/account-navigation-wrapper.j2", null, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
t_14.render(context.getVariables(), frame, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
output += t_15
output += "\n\n                </div>\n\n            ";
})});
}
output += "\n\n        </div>\n\n    ";
})});
}
else {
output += "\n\n        ";
env.getTemplate("./partials/account-navigation.j2", false, "core/templates/account-navigation-wrapper.j2", null, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
t_18.render(context.getVariables(), frame, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
output += t_19
output += "\n\n    ";
})});
}
output += "\n\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/account-navigation-wrapper.j2"] , dependencies)